import template from './asset-search.component.html';
import DebouncedToggle from '../debounced-toggle';
import * as SearchActions from '../../state/search/search.action';

export class AssetSearchController extends DebouncedToggle {
  constructor($timeout, $state, $stateParams, gettextCatalog, $ngRedux) {
    'ngInject';

    super($timeout);

    this.$timeout = $timeout;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.gettextCatalog = gettextCatalog;

    this.store = $ngRedux;
    this.showingHistory = false;
    this.searchString = '';
    this.helpContent = { helpMe: 'search' };
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
  }

  $postLink() {
    if (this.assetCount === 0) {
      this.refresh();
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    const { search, assets } = state;

    return {
      loading: search.inProgress,
      assetCount: assets.list.length
    };
  }

  _preventBubbling($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  triggerSearch() {
    if (this.searchTimeoutPromise) {
      this.$timeout.cancel(this.searchTimeoutPromise);
    }

    this.searchTimeoutPromise = this.$timeout(() => {
      this.search();
    }, 100);
  }

  search() {
    this.addQuery(this.searchString);
    window.dataLayer.push({
      event: 'search',
      attrs: {
        term: this.searchString
      }
    })
    this.searchString = '';
  }

  clearAll() {
    this.resetSearch();
  }

  navigateToAsset(asset) {
    this.$state.go('equipment.detail', {
      equipmentId: asset.id,
      title: asset.name
    });
  }

  toggleFilters() {
    this.openFilters();
  }

  toggleShowHistory($event) {
    this._preventBubbling($event);
    this._debounceToggle()
      .then(() => (this.showingHistory = !this.showingHistory))
      .catch(this._ignore);
  }

  hideHistory() {
    this._debounceToggle()
      .then(() => (this.showingHistory = false))
      .catch(this._ignore);
  }

  closeHistory() {
    this.showingHistory = false;
  }
}

export const assetSearchComponent = {
  template,
  controller: 'AssetSearchController as vm',
  bindings: {
    openFilters: '&'
  }
};
